<!--
 * @Description: 对账联系函
 * @Autor: txp
 * @Date: 2021-05-07 11:28:36
-->
<template>
  <div class="reconciliation">
    <el-card class="box-card">
      <div class="mtb20 ft12 C787878">
        <span>服务中心：</span>
        <span
          ><a href="#" class="text-decoration_none themColor" @click="goBack"
            >返回上一页</a
          ></span
        >
        <span class="el-icon-arrow-right"></span>
        <span>发货详情</span>
      </div>
      <div class="">
          <span class="orderCode">订单编号：{{orderCode}}</span>
          <!-- 暂时不要 -->
          <!-- <span class="orderCode">SAP订单编号：{{orderCode}}</span> -->
          <div v-loading="loading" style="min-height: 200px"  element-loading-spinner="el-icon-loading">
          <div v-if="deliveryData.length>0">
             <DeliveryDetailItem v-for="(item) in deliveryData" :key="item.id" :itemData="item"/>
          </div>
          <div v-else-if="!loading" class="cont">
            暂无...
          </div>
          </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import { mapGetters } from "vuex"; //主题的引用
import { deliverList,mdmdictdatas } from "@/api/api";
import DeliveryDetailItem from './deliveryDetailItem';
export default {
  name: "reconciliation",
  data() {
    return {
      orderCode: '',
      deliveryData:[],
      dms_order_state: null,
      loading: true
    };
  },
  computed: {
    ...mapGetters({
      theme: "theme",
    }),
  },
  components: {
    DeliveryDetailItem
  },
  created() {
    this.orderCode = this.$route.query.orderCode
    this.mdmdictdatas()
  },
  mounted() {
    
  },
  methods: {
    /**
     * 返回上一页
     */
    goBack() {
      this.$router.back()
    },
     // 数据字典，获取订单状态
     mdmdictdatas() {
       mdmdictdatas(["dms_order_type", "hd_order_receiving_status"])
        .then((res) => {
          if (res.code == 200) {
            this.dms_order_state = res.result.hd_order_receiving_status;
            this.getDeliveryDetail();
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    /**
     * 获取发货详情列表
     */
    getDeliveryDetail() {
      this.loading = true
      deliverList({orderCode: this.orderCode}).then((res)=>{
        this.loading = false
        this.deliveryData = res.result.data.map(item=>{
          item.stateName = this.dms_order_state.find(itemi=>itemi.dictCode===item.receivingStatus).dictValue || ''
          // item.stateName  = item.deliveryStatus
          return item
        })
        console.log(this.deliveryData)
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.reconciliation {
  height: 100%;
  /deep/.el-card{
    height: 100%;
    .cont{
      margin-top: 20px;
      text-align: center;
    }
  }
}
</style>
